<template>
  <button
    class="increase-btn"
    @click="$emit('click', $event)"
    :disabled="disabled"
  >
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class="increase-btn__path"
        :class="{ 'increase-btn__path--decrease': decrease }"
        fill-rule="evenodd"
        clip-rule="evenodd"
        :fill="disabled ? '#757575' : 'black'"
      />
    </svg>
  </button>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    decrease: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['click']
})
</script>

<style scoped lang="scss">
.increase-btn {
  @apply cursor-pointer outline-none;
  &__path {
    d: path(
      'M17.0002 0.333313C7.80016 0.333313 0.333496 7.79998 0.333496 17C0.333496 26.2 7.80016 33.6666 17.0002 33.6666C26.2002 33.6666 33.6668 26.2 33.6668 17C33.6668 7.79998 26.2002 0.333313 17.0002 0.333313ZM18.6668 15.3333V8.66664H15.3335V15.3333H8.66683V18.6666H15.3335V25.3333H18.6668V18.6666H25.3335V15.3333H18.6668ZM3.66683 17C3.66683 24.35 9.65016 30.3333 17.0002 30.3333C24.3502 30.3333 30.3335 24.35 30.3335 17C30.3335 9.64997 24.3502 3.66664 17.0002 3.66664C9.65016 3.66664 3.66683 9.64997 3.66683 17Z'
    );
    &--decrease {
      d: path(
        'M17.0002 0.333344C7.80016 0.333344 0.333496 7.80001 0.333496 17C0.333496 26.2 7.80016 33.6667 17.0002 33.6667C26.2002 33.6667 33.6668 26.2 33.6668 17C33.6668 7.80001 26.2002 0.333344 17.0002 0.333344ZM3.66683 17C3.66683 24.35 9.65016 30.3333 17.0002 30.3333C24.3502 30.3333 30.3335 24.35 30.3335 17C30.3335 9.65001 24.3502 3.66667 17.0002 3.66667C9.65016 3.66667 3.66683 9.65001 3.66683 17ZM8.66683 18.6667H25.3335V15.3333H8.66683V18.6667Z'
      );
    }
  }
}
</style>
